module.exports = __webpack_public_path__ + "static/media/bng.27f4184a.png";